/** True if `pathname` matches any route in the list (subpath/boundary match,
 *  mirroring Director's route matching). Empty/absent list → false. */
export const routeListMatches = (routes: string[] | undefined, pathname: string): boolean =>
  !!routes?.some((route) =>
    pathname.startsWith(route) &&
    (pathname.length === route.length || pathname[route.length] === '/')
  )

/** In scope when within `routes` (or site-wide) and not in `excludeRoutes`. */
export const isInRouteScope = (
  routes: string[] | undefined,
  excludeRoutes: string[] | undefined,
  pathname: string
): boolean =>
  (!routes?.length || routeListMatches(routes, pathname)) &&
  !routeListMatches(excludeRoutes, pathname)
